import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

import { AuthService } from '../services/auth.service';

@Component({
	selector: 'app-menu-lateral',
	templateUrl: './menu-lateral.component.html',
	styleUrls: ['./menu-lateral.component.css']
})
export class MenuLateralComponent implements OnInit {
    public usuario_perfil;
	public menuAberto: boolean;
    private clicado = {};
    
    public menu = [];

    public menu_dashboard_de_frotas = false;
    public menu_dashboardo_peracao = false;
    public menu_veiculos = false;
    public menu_proximas_intervencoes = false;
    public menu_checklist = false;
    public menu_embarque_de_equipe = false;
    public menu_moto = false;
    public menu_calibragem_pneus = false;
    public menu_milimetragem_pneus = false;
    public menu_mochilas = false;
    public menu_servicos_manutencao = false;
    public menu_administrativos = false;
    public menu_usuario = false;
    public menu_usuario_cadastros = false;
    public menu_usuario_fornecedores = false;
    public menu_despesas = false;
    public menu_despesa_combustivel = false;
    public menu_despesa_licenciamento_IPVA = false;
    public menu_despesa_seguro = false;
    public menu_despesa_multa = false;
    public menu_despesa_avarias_sinistros = false;
    public menu_estoque = false;
    public menu_estoque_movimentacoes = false;
    public menu_estoque_produtos = false;
    public menu_estoque_grupo = false;
    public menu_estoque_fornecedores = false;
    public menu_relatorio = false;
    public menu_relatorio_veiculos = false;
    public menu_relatorio_condutores = false;
    public menu_relatorio_checklist_ambulancias = false;
    public menu_documentos = false;
    public menu_documentos_formulario = false;
    public menu_documentos_normas = false;

    //CheckList
    public menu_ambulancias = false;

    @Output() public menuLateralEvent = new EventEmitter();

	constructor(private authSvc: AuthService,
                private router: Router,
                private perfilUsuarioSvc: PerfilUsuarioService
                ) { }

	ngOnInit() {


    	this.menuAberto = true;

        if (this.checkClass('/home/despesas')/* || // todo: colocar esses dps
                this.checkClass('/home/tiposdespesa') ||
                this.checkClass('/home/gruposdespesa') ||
                this.checkClass('/home/unidadesmedida')*/) {
            this.clicado['despesas'] = true;
        }
        else if (this.checkClass('/home/usuarios')) {
            this.clicado['admin'] = true;
        }
        else if (this.checkClass('/home/(tiposmulta|unidadesmedida)')) {
            this.clicado['admin'] = true;
            this.clicado['admin-cadastros'] = true;
        }
        else if (this.checkClass('/home/(tiposdespesa|gruposdespesa)')) {
            this.clicado['admin'] = true;
            this.clicado['admin-cadastros'] = true;
            this.clicado['admin-cadastros-despesas'] = true;
        }
        else if (this.checkClass('/home/(corretora|seguradora)')) {
            this.clicado['admin'] = true;
            this.clicado['admin-fornecedores'] = true;
        }
        else if (this.checkClass('/home/(tiposveiculo|especialidadesveiculo|marcasveiculo|modelosveiculo|coresveiculo|motivosindisponibilidade)')) {
            this.clicado['admin'] = true;
            this.clicado['admin-cadastros'] = true;
            this.clicado['admin-cadastros-veiculos'] = true;
        }
        else if (this.checkClass('/home/(manutencao|combustivel|ipva|seguro|multas)')) {
            this.clicado['despesas'] = true;
        }
        else if (this.checkClass('/home/(mochila|insumo|tipomochila)')) {
            this.clicado['admin'] = true;
            this.clicado['admin-cadastros'] = true;
            this.clicado['admin-cadastros-mochilas'] = true;
        }

        this.usuario_perfil = this.authSvc.getPerfil();

        
        this.perfilUsuarioSvc.getByVerificaPermissaoMenu(this.usuario_perfil,null).then((data: any[]) => {


            

            for(let acessoMenu of data){

                //console.log("[getByVerificaPermissaoMenu]", acessoMenu);

                switch(acessoMenu.menu_id) {

                    case 103: /*"Dashboard de Frotas"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_dashboard_de_frotas = true;
                        }
                        break;
                    }
                    case 104: /*"Dashboard de Operação"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_dashboardo_peracao = true;
                        }
                        break;
                    }
                    case 105: /*"Veículos"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_veiculos = true;
                        }
                        break;
                    }
                    case 106: /*"Próximas intervenções"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_proximas_intervencoes = true;
                        }
                        break;
                    }
                    case 113: /*"Embarque de equipe"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_embarque_de_equipe = true;
                        }
                        break;
                    }
                    case 114: /*"Serviços de Manutenção"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_servicos_manutencao = true;
                        }
                        break;
                    }
                 

                    //Checklist begin                
                    case 120: /*Ambulâncias"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_checklist = true;
                        this.menu_ambulancias = true;
                        }
                        break;
                    }
                    case 121: /*Motos"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_checklist = true;
                        this.menu_moto = true;
                        }
                        break;
                    }        
                    case 122: /*Mochilas"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_checklist = true;
                        this.menu_mochilas = true;
                        }
                        break;
                    }                        
                    case 123: /*Calibragem de pneus"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_checklist = true;
                        this.menu_calibragem_pneus = true;
                        }
                        break;
                    }        
                    case 124: /*Milimetragem de pneus"*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_checklist = true;
                        this.menu_milimetragem_pneus = true;
                        }
                        break;
                    }                        
                    //Checklist end  

                    //Administrativos begin
                    case 115: /*Administrativos*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                            this.menu_administrativos = true;
                        }
                        break;
                    }   
                    case 125: /*Administrativos / Usuários*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                            this.menu_administrativos = true;
                            this.menu_usuario = true;
                        }
                        break;
                    }   
                    case 126: /*Administrativos / Cadastros*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                            this.menu_administrativos = true;
                            this.menu_usuario_cadastros = true;
                        }
                        break;
                    } 
                    case 127: /*Administrativos / Fornecedores*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                            this.menu_administrativos = true;
                            this.menu_usuario_fornecedores = true;
                        }
                        break;
                    }   
                    //Administrativos end

                    //Despesas begin
                    case 116: /*Despesas*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        }
                        break;
                    }   
                    case 151: /*Combústivel*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        this.menu_despesa_combustivel = true;
                        }
                        break;
                    }   
                    case 152: /*Licenciamento e IPVA*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        this.menu_despesa_licenciamento_IPVA = true;
                        }
                        break;
                    }       
                    case 153: /*Seguro*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        this.menu_despesa_seguro = true;
                        }
                        break;
                    }       
                    case 154: /*Multas*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        this.menu_despesa_multa = true;
                        }
                        break;
                    }         
                    case 155: /*Avarias e Sinistros*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_despesas = true;
                        this.menu_despesa_avarias_sinistros = true;
                        }
                        break;
                    }                                                                
                    //Despesas end   
                    
                    //Estoque begin
                    case 117: /*Estoque*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_estoque = true;
                        }
                        break;
                    }      
                    case 156: /*Estoque / Movimentações*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_estoque = true;
                        this.menu_estoque_movimentacoes = true;
                        }
                        break;
                    }                    
                    case 157: /*Estoque / Produtos*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_estoque = true;
                        this.menu_estoque_produtos = true;
                        }
                        break;
                    }   
                    case 158: /*Estoque / Grupo*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_estoque = true;
                        this.menu_estoque_grupo = true;
                        }
                        break;
                    }   
                    case 159: /*Estoque / Fornecedor*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_estoque = true;
                        this.menu_estoque_fornecedores = true;
                        }
                        break;
                    }       
                    //Estoque end


                    //Relatorio begin
                    case 118: /*Estoque*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_relatorio = true;
                        }
                        break;
                    } 
                    case 163: /*Estoque / Veículos*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_relatorio = true;
                        this.menu_relatorio_veiculos = true;
                        }
                        break;
                    }     
                    case 164: /*Estoque / Condutores*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_relatorio = true;
                        this.menu_relatorio_condutores = true;
                        }
                        break;
                    }   
                    case 165: /*Estoque / Checklist Ambulâncias*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_relatorio = true;
                        this.menu_relatorio_checklist_ambulancias = true;
                        }
                        break;
                    }  
                    //Relatorio end 
                    
                    //Documentos begin
                    case 119: /*Documentos*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_documentos = true;
                        }
                        break;
                    }         
                    case 166: /*Documentos / Formulários*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_documentos = true;
                        this.menu_documentos_formulario = true;
                        }
                        break;
                    }  
                    case 167: /*Documentos / Normas*/{
                        if(acessoMenu.visualizar || acessoMenu.editar){
                        this.menu_documentos = true;
                        this.menu_documentos_normas = true;
                        }
                        break;
                    }                      

                     //Documentos end


               }

            }

        }).catch((err) => {
            console.log(err);scrollBy
        });   

	}

    clicaItemComSubmenu(nome) {
        this.clicado[nome] = !this.clicado[nome];
    }

	checkClass(path) {
		let regex = new RegExp('^' + path);
		return regex.test(this.router.url);
	}

    checkAberto(nome) {
        if (this.clicado[nome] === undefined) 
            this.clicado[nome] = false;
        return this.clicado[nome];
    }

	minimizaMenu() {
		this.menuAberto = false;
	}

	maximizaMenu() {
		this.menuAberto = true;
    }

    emitClick(){
        this.menuLateralEvent.emit(true);
    }
    
}
